module.exports = __webpack_public_path__ + "static/media/sn.02f6c9d3.png";